import _ from "lodash";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import TinyDatePicker from 'tiny-date-picker';

import { withValidation } from "../hocs/WithValidation";
import {
    withValidationOutputPropTypes,
    sharedFormInputPropTypes,
} from "../hocs/prop-types";

class DatePicker extends Component {
    constructor(props) {
        super(props);
        this.datePickerRef = React.createRef();
        this.tdpConfig = {
            mode: 'dp-below',
            lang: {
                days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            },
            min: '01/1/2008',
            max: '01/1/2068',
            format: date => date
                .toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                })
                .replace(/[^ -~]/g, ''),
        };
        this.state = {
            date: this.props.startDate
        }
    }
    componentDidMount() {
        const { datePickerConfig, startDate, onChangeValue } = this.props;
        this.setState({
            date: startDate
        });
    }

    render() {
        const {
            className,
            parentContainerClassName,
            id,
            name,
            value,
            width,
            onChangeValue,
            label,
            datePickerConfig
        } = this.props;

        if (this.datePickerRef.current) {
            let dp = TinyDatePicker(
                this.datePickerRef.current,
                Object.assign(this.tdpConfig, datePickerConfig)
            );

            dp.on('statechange', (_, picker) => {
                onChangeValue(picker.state.hilightedDate);
            });
        }

        return (
            <Fragment>
                <div className="sprk-u-JavaScript">
                    <div className={parentContainerClassName || "sprk-b-InputContainer"}>
                        {label && (
                            <label className="sprk-b-Label" htmlFor={id}>
                                {label}
                            </label>
                        )}
                        <input
                            ref={this.datePickerRef}
                            autoComplete="false"
                            className={className}
                            id={id}
                            name={name}
                            value={value}
                            onChange={onChangeValue}
                            width={width}
                            readOnly
                        >
                        </input>
                    </div>
                </div>
            </Fragment>
        );
    }
}

DatePicker.defaultProps = {
    forceUpdate: false,
    handleChange: () => { },
    parentContainerClassName: null
};

DatePicker.propTypes = {
    ...sharedFormInputPropTypes,
    handleChange: PropTypes.func,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    startDate: PropTypes.string,
    onChangeValue: PropTypes.func.isRequired,
    label: PropTypes.string,
    parentContainerClassName: PropTypes.string
};

export default DatePicker;
